import { render, staticRenderFns } from "./getTicket.vue?vue&type=template&id=1a3938c9&"
import script from "./getTicket.vue?vue&type=script&lang=js&"
export * from "./getTicket.vue?vue&type=script&lang=js&"
import style0 from "./getTicket.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports